import './styles.css';

import React, { useState } from 'react';

import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid } from '@material-ui/core';

import { mask } from 'remask';
import { XMEI_PRIMARY_COLOR } from '../../../consts/common';
import FormBoleto from './formBoleto';

const useStyles = makeStyles((theme) => ({
  hidden: { display: 'none' },
}));

function PagamentoComBoleto(props) {
  const classes = useStyles(props);
  const [tabValue, setTabValue] = useState(0);

  /**
   * Form Validation Schema
   */
  const schema = yup.object().shape({
    cep: yup.string().required('CEP deve ser preenchido para busca'),
    logradouro: yup.string().required('Logradouro deve ser preenchido'),
    numero: yup.string().required('Numero deve ser preenchido'),
    bairro: yup.string().required('Bairro deve ser preenchido'),
    cidade: yup.string().required('Cidade deve ser preenchido'),
    estado: yup.string().required('Estado deve ser preenchido'),
  });

  const methods = useForm({
    mode: 'onBlur',
    defaultValues: {
      segmento_atuacao_nome: '',
      tipoEmpresa: 0,
      tipoTributacao: 0,
    },
    resolver: yupResolver(schema),
  });

  const { register, reset, control, onChange, onBlur, formState } = methods;
  /**
   * Tab Change
   */
  function handleTabChange(value) {
    setTabValue(value);
  }

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justify="center"
      style={{ minHeight: '100vh', backgroundColor: XMEI_PRIMARY_COLOR }}
    >
      <Paper
        elevation={10}
        style={{
          width: '70%',
          backgroundColor: '#FFF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 30,
          paddingBottom: 30,
        }}
      >
        <div style={{ width: 250, marginBottom: 20 }}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            style={{
              display: 'block',
              width: '100%',
              height: 'auto',
            }}
          />
        </div>
        <FormProvider {...methods}>
          <FormBoleto state={props.location} />
        </FormProvider>
      </Paper>
    </Grid>
  );
}

export default PagamentoComBoleto;
